import React from 'react';
import { BIG_QUERY_CLUSTER_KEY_DATA_TYPES } from '../constants/constants';

export function PartitionStylePopUp() {
  return (
    <div>
      <div className='mb-2'>Types of table partitioning</div>
      <ul className='popup-ul'>
        <li>
          <span className='text-bold'>Ingestion Time Based: </span>
          <span>Tables partitioned based on the data's ingestion (load) date or arrival date</span>
        </li>

        <li>
          <span className='text-bold'>Field Based: </span>
          <span>Tables that are partitioned based on a TIMESTAMP or DATE column.</span>
        </li>
      </ul>
    </div>
  );
}

export function BigQueryClusterKeyTooltipMessage({ field, bigQueryClusterKeysLimitReached }) {
  if (!field?.dataType || !field.dataType?.type) {
    return <>Please select one of the allowed datatype</>;
  }

  if (!BIG_QUERY_CLUSTER_KEY_DATA_TYPES.includes(field.dataType.type.toLowerCase())) {
    return (
      <>{`BigQuery does not allow ${field.dataType.type_display} datatype for a clustering key`} </>
    );
  }

  if (bigQueryClusterKeysLimitReached) {
    return <>Only 4 Cluster Keys can be selected</>;
  }
  return null;
}
